<template>
  <div>
    <div class="customer1"></div>
    <div class="record2">
      <el-form ref="added" inline size="medium">
        <el-form-item label="服务对象名称">
          <el-input v-model="query.name_or_phone" placeholder="请输入服务对象名称或手机号" clearable @keyup.enter.native="search">
          </el-input>
        </el-form-item>
        <el-form-item label="社工名称">
          <el-input v-model="query.founders" placeholder="社工名称或手机号" clearable @keyup.enter.native="search">
          </el-input>
        </el-form-item>
        <el-form-item label="重要程度">
          <el-select v-model="query.important_degree" placeholder="请选择" clearable style="width: 120px;">
            <el-option label="全部" value=""></el-option>
            <el-option label="普通" :value="0"></el-option>
            <el-option label="一般" :value="1"></el-option>
            <el-option label="重要" :value="2"></el-option>
            <el-option label="非常重要" :value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="isChild" label="服务对象类型">
          <el-select v-model="query.type" placeholder="请选择" clearable style="width: 120px;">
            <el-option label="全部" value=""></el-option>
            <el-option label="孤儿" :value="1"></el-option>
            <el-option label="事实无人抚养儿童" :value="2"></el-option>
            <el-option label="留守儿童" :value="3"></el-option>
            <el-option label="低保儿童" :value="4"></el-option>
            <el-option label="特困儿童" :value="5"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="服务对象状态">
          <el-select v-model="query.is_death" placeholder="请选择" clearable style="width: 100px;">
            <el-option label="全部" value=""></el-option>
            <el-option label="正常" :value="0"></el-option>
            <el-option label="去世" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区域">
          <el-cascader v-model="query.code" ref='area' :options="areaList" clearable popper-class='myArea' :props="{
            expandTrigger: 'hover',
            children: 'child',
            label: 'area_name',
            value: 'area_code',
            checkStrictly: true
          }" @change="handleChange"></el-cascader>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission, 'customer/query')">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission, 'customer/query')">
          <el-button type="info" icon="el-icon-refresh-right" @click="reset"> 重置 </el-button>
        </el-form-item>
        <div></div>
        <span style="padding-left: 70px;"></span>
        <el-form-item v-if="JudgeButton(role_permission, 'customer/download')">
          <el-button type='info' icon="el-icon-download" @click="dwonload">模板下载</el-button>
        </el-form-item>
        <el-form-item>
          <el-upload v-if="JudgeButton(role_permission, 'customer/inport')" :auto-upload="false"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" action
            :show-file-list='false' :on-change="handleChansge">
            <el-button type="success" icon="el-icon-circle-plus-outline">导入服务对象</el-button>
          </el-upload>
        </el-form-item>

        <!-- <el-form-item v-if="JudgeButton(role_permission,'customer/export')">
          <el-button :disabled="!list.length || downloading" type="warning" icon="el-icon-printer"
            @click="printting">智能打印
          </el-button>
        </el-form-item> -->

        <el-form-item v-if="JudgeButton(role_permission, 'customer/print')">
          <el-button :disabled="!list.length || downloading" v-loading='downloading' type="warning"
            icon="el-icon-printer" @click="$refs.filter.show(query)">智能打印
          </el-button>
        </el-form-item>

        <el-form-item v-if="JudgeButton(role_permission, 'customer/export')">
          <el-button :disabled="!list.length" type="warning" icon="el-icon-upload2" @click="handleExport">导出服务对象
          </el-button>
        </el-form-item>

        <el-form-item v-if="JudgeButton(role_permission, 'customer/allocation')">
          <el-button :disabled="!multipleSelection.length" type="danger" icon="el-icon-connection"
            @click="handleDistribute">批量分配</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="customer3">
      <el-table v-loading='loading' stripe border ref="multipleTable" :data="list" tooltip-effect="dark"
        style="width: 98%" @selection-change="handleSelectionChange">
        <el-table-column :selectable="checkSelectMember" align='center' type="selection" width="55">
        </el-table-column>

        <el-table-column align='center' prop='customer_name' label="姓名" width="120">
          <template slot-scope="scope">
            <span style="color: #2F91FE;cursor: pointer;" @click="detailsReset(scope.$index, scope.row)">{{
              scope.row.customer_name || '--'
            }}</span>
            <span class="death" v-if="scope.row.is_death == 1">已去世</span>
          </template>
        </el-table-column>

        <el-table-column align='center' prop="name" label="性别" width="80">
          <template slot-scope="scope">
            {{ scope.row.customer_sex | isSex }}
          </template>
        </el-table-column>

        <el-table-column align='center' prop="customer_age" label="年龄" width="80">
        </el-table-column>

        <el-table-column align='center' label="重要程度" width="130">
          <template slot-scope="scope">
            <span :class="'state-' + scope.row.customer_important_degree">{{
              scope.row.customer_important_degree |
                isImportant
            }}</span>
          </template>
        </el-table-column>

        <el-table-column align='center' prop="customer_phone" label="手机号" width='150px'>
        </el-table-column>

        <!-- 只有儿童版本才会展示该字段 -->
        <el-table-column v-if="isChild" align='center' prop="customer_type" label="服务对象类型" width="120">
          <template slot-scope="scope">
            {{ scope.row.customer_type | typeText }}
          </template>
        </el-table-column>
        <el-table-column label="类型" align='center'>
          {{ cusType }}
        </el-table-column>
        <el-table-column align='center' prop="customer_area_name" label="居住区域" show-overflow-tooltip>
        </el-table-column>
        <!-- <el-table-column align='center'
                  prop="customer_current_address"
                  label="现住地址"
                  show-overflow-tooltip
                 >
                </el-table-column> -->
        <el-table-column align='center' prop="founders" label="服务社工" width="110"></el-table-column>

        <el-table-column align='center' prop="address2" label="当月服务情况" width="230">
          <template slot-scope="scope">
            <span
              v-if="!scope.row.current_month_service_total_online && !scope.row.current_month_service_total_offline">
              未服务
            </span>
            <span v-else>
              线上（<span style="color: #2F91FE;">{{ scope.row.current_month_service_total_online || 0 }}</span>）
              线下（<span style="color: #2F91FE;">{{ scope.row.current_month_service_total_offline || 0 }}</span>）
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column align='center'
				   label="当月服务状态"
				   width="120">
				   <template slot-scope="scope">
				  		<span v-if="scope.row.current_month_service_audit_status == 0" style="color: #999999;">未审核</span>
				  		<span v-if="scope.row.current_month_service_audit_status == 1" style="color: #7FC418;">合格</span>
						<span v-if="scope.row.current_month_service_audit_status == 2" style="color: #E65D6E;">不合格</span>
						<span v-if="scope.row.current_month_service_audit_status == 3" style="color: #DF384C;">终审不合格</span>
						<span v-if="scope.row.current_month_service_audit_status == 4" style="color: #7FC418;">预审合格</span>
				  </template>
				</el-table-column> -->
        <el-table-column width='200px' align='center' prop="add_time" label="创建时间">
        </el-table-column>

        <el-table-column label="操作" align='center' width='300px'>
          <template slot-scope="scope">
            <!-- <el-button
						size="mini"
						type="primary"
						@click="hanReset(scope.$index, scope.row)">服务记录</el-button> -->
            <div class="options">

              <el-button v-if="JudgeButton(role_permission, 'customer/details')" size="mini" type="primary"
                @click="detailsReset(scope.$index, scope.row)">详情</el-button>
              <el-button v-if="JudgeButton(role_permission, 'customer/edit')" size="mini" type="primary"
                @click="handleServiceEnable(scope.$index, scope.row)">{{
                  scope.row.is_enjoy_service == 0 ? '开启服务' : '暂停服务'
                }}</el-button>
              <el-button size="mini" type="warning"
                v-if="scope.row.is_death == 0 && JudgeButton(role_permission, 'customer/edit')"
                @click="handleDeath(scope.$index, scope.row)">去世</el-button>
              <el-button v-if="JudgeButton(role_permission, 'customer/delete')" size="mini" type="danger"
                @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin: 30px auto;text-align: center;" v-if="query.total > 0"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
        :page-sizes="[10, 20, 50, 100]" :page-size="query.page_limit" layout="total, sizes, prev, pager, next, jumper"
        :total="query.total">
      </el-pagination>
    </div>
    <el-dialog title="批量分配" :visible.sync="dialogVisible" width="33%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" style="min-height: 300px;">
        <el-form-item label="服务对象姓名:" style="margin-bottom: 0px;">
          <span class="cu" v-for="(item, i) in multipleSelection" :key="i">{{ item.customer_name }}</span>
        </el-form-item>
        <el-form-item label="请选择社工:" prop="user_id">
          <el-radio-group v-model="ruleForm.user_id">
            <el-radio style="margin-top: 15px;" :label="item.user_id" v-for="(item, index) in userList" :key="index">
              {{ item.user_name }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleComfirm">确 定</el-button>
      </div>
    </el-dialog>
    <printFilterDialog ref="filter" @success='printtingTest' />

    <iframe v-if="showPdf" src="/pdf.html" frameborder="0" width="1400" height="3000"
      style="position: fixed;top: -999999px;right: -99999px;"></iframe>
    <!-- -->
  </div>
</template>

<script>
import userInfoAPI from '@/api/api';
import printFilterDialog from './components/printFilterDialog.vue';
import Txt from '@/config/txt.js'
var that;
// 通过域名判断是否是儿童社工
const isChild = window.location.host.indexOf('childks') > -1

export default {
  name: 'customerManage',
  components: {
    printFilterDialog
  },
  data() {
    return {
      isChild: isChild,
      loading: true,
      list: [],
      important: ['普通', '一般', '重要', '非常重要'],
      areaList: [],
      query: {
        name_or_phone: '',
        type: '',   // 儿童类型
        important_degree: '',
        is_death: '',
        founders: '',
        area_code: '',
        village_code: '', // 村code
        page_limit: 10,
        page: 1,
        flag: '', // 操作标志 export=数据导出
        total: 0
      },
      multipleSelection: [],
      dialogVisible: false,

      userList: [],
      userPage: 1,
      ruleForm: {
        user_id: ''
      },
      rules: {
        user_id: [{
          required: true,
          message: '请选择社工',
          trigger: 'change'
        }],
      },
      downloading: false,
      lockLoading: null,
      showPdf: false
    }
  },
  computed: {
    role_permission() {
      return this.$store.getters.role_permission
    },
    cusType(){
      return Txt['cusType']
    }
  },
  beforeDestroy() {
    this.$store.commit('CACHE_CUSTOMER', this.query)
  },
  created() {
    that = this;
    if (this.$store.state.cache.cacheCustomerQuery) this.query = this.$store.state.cache.cacheCustomerQuery
    this.query.flag = ''
    this.getList()
  },
  methods: {
    search() {
      this.loading = true;
      this.query.flag = '';
      this.query.page = 1;
      this.list = [];
      this.getList()
    },
    JudgeButton(list, rot) {
      let fal = false;
      list.forEach((i, l) => {
        if (i.path == rot) {
          return fal = true;
        }
      })
      return fal
    },
    checkSelectMember(row, index) {
      // return row.founders === false || row.founders === ''
      return true
    },
    handleSelectionChange(val) { //是否全选框框
      this.multipleSelection = val;
    },
    handleChansge(file, fileList) {
      let formData = new FormData();
      formData.append('import_file', file.raw)
      userInfoAPI.customerImport(formData).then(({
        data
      }) => {
        if (data.code == 0) {
          this.getList()
          this.$message({
            type: 'success',
            message: '服务对象导入成功!'
          });
        } else {
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    dwonload() {
      userInfoAPI.systemFileDownload({
        flag: 'customer_import_dome'
      }).then(({
        data
      }) => {
        if (data) {
          let blob = new Blob([data], {
            type: 'application/vnd.ms-excel'
          })
          let objectUrl = URL.createObjectURL(blob)
          let link = document.createElement('a')
          link.href = objectUrl
          link.setAttribute('download', '服务对象导入模板.xlsx')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(objectUrl)
          this.$message({
            type: 'success',
            message: '下载成功!'
          });
        }
      })
    },
    handleExport() {
      this.query.flag = 'export';
      this.getList();
    },
    getUserList() {
      userInfoAPI.serviceUserList({
        page_limit: 99,
        page: this.userPage,
      }).then(res => {
        if (res.data.code == 0) {
          this.userList = this.userList.concat(res.data.data.list || [])
          if (res.data.data.list.length == 99) {
            this.userPage++
            this.getUserList()
          }
        }
      })
    },
    handleDistribute() {
      this.ruleForm.user_id = ''
      this.userPage = 1
      this.userList = []
      this.getUserList()
      this.dialogVisible = true
    },
    handleChange(e) {
      if (e[0]) {
        this.query.area_code = e[0]
        this.query.village_code = e[1] || ''
        if (e[1]) {
          that.$refs.area.dropDownVisible = false
        }
      } else {
        this.query.area_code = ''
        this.query.village_code = ''
      }
    },
    handleComfirm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          userInfoAPI.customerAllocation({
            user_id: this.ruleForm.user_id,
            customer_id: this.multipleSelection.map(i => {
              return i.customer_id
            }).join(',')
          }).then(({
            data
          }) => {
            if (data.code == 0) {
              this.getList()
              this.dialogVisible = false
              this.$message({
                type: 'success',
                message: '分配成功!'
              });
            } else {
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'error'
              })
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    reset() {
      this.query.name_or_phone = ''
      this.query.founders = ''
      this.query.important_degree = ''
      this.query.is_death = ''
      this.query.area_code = ''
      this.query.village_code = ''
      this.query.code = ''
    },
    handleServiceEnable(index, row) {

      const tips = row.is_enjoy_service == 1 ? `确定要将 ${row.customer_name} 设置为无法享受服务吗？` : `确定要将 ${row.customer_name} 设置为可以享受服务吗？`

      this.$confirm(tips, '温馨提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        userInfoAPI.serviceCustomerEdit({
          customer_id: row.customer_id,
          is_enjoy_service: row.is_enjoy_service == 0 ? 1 : 0
        }).then(({
          data
        }) => {
          if (data.code == 0) {
            this.getList()
            this.$message({
              type: 'success',
              message: '设置成功!'
            });
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            })
          }
        })
      })
    },
    handleDeath(index, row) {
      this.$confirm('确定要将“' + row.customer_name + '”设置为去世吗, 设置后将不能更改', '温馨提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        userInfoAPI.serviceCustomerEdit({
          customer_id: row.customer_id,
          is_death: 1
        }).then(({
          data
        }) => {
          if (data.code == 0) {
            this.getList()
            this.$message({
              type: 'success',
              message: '设置成功!'
            });
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            })
          }
        })
      })
    },
    handleDelete(index, row) { //删除
      if (row.is_service_ing == 1) {
        this.$message({
          type: 'error',
          message: '该人员正在服务中，禁止删除操作！'
        })
        return
      }
      this.$confirm('是否确定删除该服务对象, 是否继续?', '删除提醒', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        userInfoAPI.serviceCustomerDel({
          customer_id: row.customer_id
        }).then(({
          data
        }) => {
          if (data.code == 0) {
            this.getList()
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            })
          }
        })
      })
    },
    detailsReset(index, row) { //详情
      this.$router.push({
        name: 'details1',
        query: {
          customer_id: row.customer_id
        }
      })
    },
    getList() {
      this.loading = true
      this.showPdf = false
      userInfoAPI.customerList(this.query).then(res => {
        if (this.query.flag == 'export') {
          let blob = new Blob([res.data], {
            type: 'application/vnd.ms-excel'
          })
          let objectUrl = URL.createObjectURL(blob)
          let link = document.createElement('a')
          link.href = objectUrl
          link.setAttribute('download', '服务对象人员名单')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(objectUrl)
        } else {
          if (res.data.code == 0) {
            this.list = res.data.data.list || []
            this.query.total = res.data.data.page.count || 0
          }
        }
        this.getAreaList()
        this.loading = false
      })
    },
    getAreaList() {
      userInfoAPI.systemSelectionList().then(({
        data
      }) => {
        if (data.code == 0) {
          this.areaList = data.data;
        } else {
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    handleSizeChange(val) {
      this.query.flag = '';
      this.query.page_limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.query.flag = '';
      this.query.page = val;
      this.getList();
    },
    printting() {
      this.lockLoading = this.$loading({
        lock: true,
        text: 'PDF正在合成，请稍等',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.downloading = true;
      this.$refs.print.download()
    },
    printtingTest(list) {
      this.downloading = true
      this.showPdf = false
      let title = '服务对象基本信息'
      if (this.query.is_death === 1) {
        title = '已去世的' + title
      }
      list = list === -1 ? this.list : list
      window.localStorage.setItem('ServicePrintList', JSON.stringify(list))
      window.localStorage.setItem('ServicePrintTitle', title)
      setTimeout(() => {
        this.showPdf = true
      }, 520)
      let c = 5000
      if (this.query.page_limit == 20) c = 8000
      if (this.query.page_limit == 50) c = 15000
      if (this.query.page_limit == 100) c = 20000
      setTimeout(() => {
        this.downloading = false
      }, c)
    }
  }
}
</script>
<style lang='scss' scoped>
.customer1 {
  height: 20px;
}

.death {
  position: absolute;
  top: -1px;
  left: -3px;
  background: #b52929;
  color: white;
  padding: 0 5px;
  transform: scale(0.85);
}

.state-2 {
  color: #e4be44;
}

.state-3 {
  color: red;
}

.customer3 {
  margin-left: 20px;
}

.cu {
  &::after {
    content: '、';
  }

  &:nth-last-child(1)::after {
    content: '';
  }
}

.record2 .el-form-item {
  margin-left: 20px;
}

.options {
  overflow: hidden;
  flex-flow: row wrap;
  line-height: 2.5rem;
}
</style>
